var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ivu-tag-select-option"},[_c('Tag',_vm._b({attrs:{"checkable":"","checked":_vm.checked,"color":_vm.color},on:{"on-change":_vm.handleChange}},'Tag',_vm.tagProps,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/tag-select/tag-select-option.vue